module.exports = __webpack_public_path__ + "img/appltCourse-img37.05687d3c.png";